/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelByGroupRequest
 */
export interface CancelByGroupRequest {
  /**
   *
   * @type {string}
   * @memberof CancelByGroupRequest
   */
  groupKey: string;
}

/**
 * Check if a given object implements the CancelByGroupRequest interface.
 */
export function instanceOfCancelByGroupRequest(
  value: object,
): value is CancelByGroupRequest {
  if (!("groupKey" in value) || value["groupKey"] === undefined) return false;
  return true;
}

export function CancelByGroupRequestFromJSON(json: any): CancelByGroupRequest {
  return CancelByGroupRequestFromJSONTyped(json, false);
}

export function CancelByGroupRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelByGroupRequest {
  if (json == null) {
    return json;
  }
  return {
    groupKey: json["groupKey"],
  };
}

export function CancelByGroupRequestToJSON(json: any): CancelByGroupRequest {
  return CancelByGroupRequestToJSONTyped(json, false);
}

export function CancelByGroupRequestToJSONTyped(
  value?: CancelByGroupRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    groupKey: value["groupKey"],
  };
}
